"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _shader = _interopRequireDefault(require("./shader"));

var goldBase = '#D4A419';
var gold = {
  dark40: (0, _shader["default"])(-0.4, goldBase),
  //#1E1703
  dark30: (0, _shader["default"])(-0.3, goldBase),
  //#4B3A09
  dark20: (0, _shader["default"])(-0.2, goldBase),
  //#795D0E
  dark10: (0, _shader["default"])(-0.1, goldBase),
  //#A68114
  base: goldBase,
  light10: (0, _shader["default"])(0.1, goldBase),
  //#E8BB38
  light20: (0, _shader["default"])(0.2, goldBase),
  //#EDCA66
  light30: (0, _shader["default"])(0.3, goldBase),
  //#F2DA94
  light40: (0, _shader["default"])(0.4, goldBase),
  //#F8EAC1
  light45: (0, _shader["default"])(0.45, goldBase) //#FAF2D8

};
var _default = gold;
exports["default"] = _default;